<template>
  <div class = "st-table">
    <el-card shadow="always">
      <el-form :model="formItem" label-position="left" label-width="145px" label-colon>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Date" :span="12">
              <el-date-picker
                type="date"
                v-model="formItem.date"
                @change="formItem.date = $event"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <div style="margin-top: 5px">
            <el-button type="primary" @click="onSubmit">
              Transfer
            </el-button>
          </div>
        </el-row>
      </el-form>
    </el-card>
    <br/>
    <el-card shadow="always">
      <el-form :model="query" label-width="80px" label-colon>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item
              label="Name"
              :span="11"
            >
              <el-select
                v-model="query.user"
                filterable
                clearable
                :loading="loading1"
              >
                <el-option
                  v-for="(option) in options.users"
                  :value="option.value"
                  :key="option.label"
                  :label="option.label"
                >
                  {{option.label}}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Date" :span="11" label-width="120px">
              <el-date-picker
                v-model="query.operationDate"
                type="daterange"
                align="right"
                range-separator="to"
                :editable="false"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="16">
          <el-col :span="6">
            <el-button type="text" class="btn" @click="handleReset">
              Reset
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" class="btn" @click="getComp">
              Search
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <br/>
    <el-card shadow="always" title="Comp List" style="width: 100%">
      <el-form>
        <el-table
          :data="compList" border style="width: 100%">
          <el-table-column
            prop="fullName"
            label="Name"
          >
          </el-table-column>
          <el-table-column
            prop="date"
            label="Date"
          >
          </el-table-column>

          <el-table-column
            prop="record"
            label="Record"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="query.currentPage"
          :page-sizes="[10,20,50]"
          :total="query.totalPage"
          :page-size.sync="query.pageSize"
          prev-text="Previous"
          next-text="Next"
          style="margin-top: 4px"
          show-total
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-form>

    </el-card>

  </div>
</template>

<script>
import attendanceApi from "@/api/attendance";
import userApi from "@/api/user";


export default {
  name: "attTransfer",
  data() {
    return {
      compList: [],
      formItem: {
        date: ''
      },
      options: {
        users:[],
      },
      query: {
        date_from: '',
        date_to: '',
        user: '',
        currentPage: 1,
        pageSize: 10,
        totalPage: 0,
      },
      loading1: false,

    }
  },
  methods: {
    onSubmit() {
      let payload = this.formItem
      payload['date'] = this.formItem.date
      attendanceApi.createComp(payload).then()
    },
    getComp() {
      let para = {}
      if (this.query.operationDate) {
        para['date_from'] = this.query.operationDate[0]
        para['date_to'] = this.query.operationDate[1]
      }
      para['offset'] = this.query.pageSize * (this.query.currentPage -1)
      para['limit'] = this.query.pageSize
      if (this.query.user) {
        para['user_id'] = this.query.user
      }
      attendanceApi.getComp(para).then(
        res => {
          this.compList = res.data.data
          this.query.totalPage = res.data.total
        }
      )
    },
    handleReset() {
      this.query.operationDate = null
      this.query.user = null
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.options.users.push({value: user.id, label: user["fullName"]})
        }
      })
    }
  },
  mounted() {
    this.getSelects()
  }
  }

</script>



<style scoped>

</style>
